import React from "react";
import Form from "react-bootstrap/Form";
import {Col, Row} from "react-bootstrap";
import Button from "react-bootstrap/Button";
import ComboFclty from "../../components/inputs/ComboFclty";
import ComboRepeater from "../../components/inputs/ComboRepeater";
import ComboCtlType from "../../components/inputs/ComboCtlType";
// import ComboInputPeriod from "../../components/inputs/ComboInputPeriod";
import ComboInputPeriodV2 from "../inputs/ComboInputPeriodV2";

const DateFacilityRepeaterControlSearchBox = ({
                                                searchParam,
                                                setSearchParam,
                                                updateList,
                                                setCurrentPage
                                              }) => {

  const onChangeStartDate = (date) => {
    setSearchParam((prev) => {
      return {...prev, startDate: date};
    });
  };

  const onChangeStartHour = (value) => {
    setSearchParam((prev) => {
      return {...prev, startHour: value};
    });
  };

  const onChangeEndDate = (date) => {
    setSearchParam((prev) => {
      return {...prev, endDate: date};
    });
  };

  const onChangeEndHour = (value) => {
    setSearchParam((prev) => {
      return {...prev, endHour: value};
    });
  };

  const onChangeFacilityName = (e) => {
    setSearchParam((prev) => {
      return {...prev, searchFcltyNo: e.target.value};
    });
  };

  // 중계기
  const onChangeSearchRpeatNo = (e) => {
    setSearchParam((prev) => {
      return {...prev, searchRpeatNo: e.target.value};
    });
  };

  // 센서 유형
  const onChangeControlType = (e) => {
    setSearchParam((prev) => {
      return {...prev, searchCtrlTy: e.target.value};
    });
  };

  const onClickSearch = (e) => {
    e.preventDefault();
    updateList();
    setCurrentPage(1);
  };

  return (
      <>
        <Form
            id={"searchForm"}
            className={"search-form"}
            onSubmit={onClickSearch}
        >
          <Row className={"justify-content-center"}>
            <Col md={12}>
              <Row className={"text-center"}>
                <Col md={10}>
                  <Row className={"gy-2"}>

                    {/*<Col md={9} className={"mb-3"}>*/}
                    <Col xxl={10} xl={12} lg={12} md={12}>
                      <ComboInputPeriodV2
                          propSearchParam={searchParam}
                          propOnChangeStart={onChangeStartDate}
                          propOnChangeEnd={onChangeEndDate}
                          propOnChangeStartHour={onChangeStartHour}
                          propOnChangeEndHour={onChangeEndHour}
                          // propLabelSize={1}
                          // propInputSize={5}
                      />
                    </Col>

                    {/*<Col md={3} className={""}>*/}
                    <Col xxl={3} xl={4} lg={4} md={6}>
                      <ComboFclty
                          propOnChange={onChangeFacilityName}
                      />
                    </Col>

                    {/*<Col md={3}>*/}
                    <Col xxl={3} xl={4} lg={4} md={6}>
                      <ComboRepeater
                          propFilterFclty={searchParam.searchFcltyNo}
                          propOnChange={onChangeSearchRpeatNo}
                      />
                    </Col>

                    {/*<Col md={3}>*/}
                    <Col xxl={3} xl={4} lg={4} md={6}>
                      <ComboCtlType
                          propType={'2'}
                          propOnChange={onChangeControlType}
                      />
                    </Col>
                  </Row>
                </Col>
                <Col md={2} className={"search-btn-container"}>
                  <Button type={"submit"} className={"search-btn px-5"}>
                    검색
                  </Button>
                </Col>
              </Row>
            </Col>
          </Row>
        </Form>
      </>
  )
      ;
};

export default DateFacilityRepeaterControlSearchBox;

